import { SvgIcon } from "@mui/material";

export default function DevicesApple(props) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path d="M22,10H18a2,2,0,0,0-2,2v8a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V12A2,2,0,0,0,22,10Zm0,10H18V12h4Zm.5-18H1.5A1.5,1.5,0,0,0,0,3.5v13A1.5,1.5,0,0,0,1.5,18H10l-.45.89A2,2,0,0,1,7.74,20H7.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H14V14H2V4H22V8h2V3.5A1.5,1.5,0,0,0,22.5,2Z" />
    </SvgIcon>
  );
}
